import React from 'react';
import { cn } from 'cn';

type ContainerProps = React.ComponentPropsWithoutRef<'div'> & {
  /** Ocupa a largura toda, sem a largura máxima por breakpoint. */
  fluid?: boolean;
};

/**
 * Bloco centralizado com 12px de padding lateral e largura máxima pelo tamanho da tela, não do pai (540/720/960/1200px; no print, no mínimo 992px, como no modern.css). Com `fluid`, ocupa a largura toda. Substitui o `Container` do reactstrap.
 * @import import Container from 'src/componentes/container';
 */
export default function Container({
  fluid,
  className,
  ...props
}: ContainerProps) {
  return (
    <div
      className={cn(
        'tw:mx-auto tw:w-full tw:px-3',
        !fluid &&
          'tw:min-[576px]:max-w-[540px] tw:min-[768px]:max-w-[720px] tw:min-[992px]:max-w-[960px] tw:min-[1200px]:max-w-[1200px] tw:print:min-w-[992px]!',
        className
      )}
      {...props}
    />
  );
}
